/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * order-business-service
 * business order api
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


import * as Url from 'url'

const url = Url as any
url.URLSearchParams = URLSearchParams

/**
 *
 *@export
 *@interface FetchArgs
 */
export interface FetchArgs {
  url: string;
  options: any;
  abort: () => void
}

/**
 *
 *@export
 *@class RequiredError
 *@extends {Error}
 */
export class RequiredError extends Error {
  name = "RequiredError"

  constructor(public field: string, msg?: string) {
    super(msg);
  }
}

/**
 * 
 * @export
 * @interface DeliveryAddressRequest
 */
export interface DeliveryAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof DeliveryAddressRequest
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryAddressRequest
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryAddressRequest
     */
    district: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryAddressRequest
     */
    province: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryAddressRequest
     */
    receiver_name: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryAddressRequest
     */
    receiver_phone: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryAddressRequest
     */
    street: string;
}

/**
 * 
 * @export
 * @interface DeliveryAddressResponse
 */
export interface DeliveryAddressResponse {
    /**
     * 
     * @type {string}
     * @memberof DeliveryAddressResponse
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryAddressResponse
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryAddressResponse
     */
    district?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryAddressResponse
     */
    province?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryAddressResponse
     */
    receiver_name?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryAddressResponse
     */
    receiver_phone?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryAddressResponse
     */
    street?: string;
}

/**
 * 
 * @export
 * @interface InvoiceResponse
 */
export interface InvoiceResponse {
    /**
     * 地址
     * @type {string}
     * @memberof InvoiceResponse
     */
    company_address?: string;
    /**
     * 公司title
     * @type {string}
     * @memberof InvoiceResponse
     */
    company_name?: string;
    /**
     * 银行账号
     * @type {string}
     * @memberof InvoiceResponse
     */
    open_bank_account?: string;
    /**
     * 银行分行
     * @type {string}
     * @memberof InvoiceResponse
     */
    open_bank_name?: string;
    /**
     * 纳税人账号
     * @type {string}
     * @memberof InvoiceResponse
     */
    tax_account?: string;
    /**
     * 手机
     * @type {string}
     * @memberof InvoiceResponse
     */
    tel_number?: string;
}

/**
 * 
 * @export
 * @interface KeyValue
 */
export interface KeyValue {
    /**
     * 
     * @type {string}
     * @memberof KeyValue
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof KeyValue
     */
    value?: string;
}

/**
 * 
 * @export
 * @interface OrderAuditHistoryResponse
 */
export interface OrderAuditHistoryResponse {
    /**
     * 
     * @type {OrderContentResponse}
     * @memberof OrderAuditHistoryResponse
     */
    content?: OrderContentResponse;
    /**
     * 
     * @type {string}
     * @memberof OrderAuditHistoryResponse
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderAuditHistoryResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderAuditHistoryResponse
     */
    order_no?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderAuditHistoryResponse
     */
    type?: OrderAuditHistoryResponse.TypeEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderAuditHistoryResponse
     */
    updated_by?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderAuditHistoryResponse
     */
    updated_by_user_id?: string;
}

/**
 * @export
 * @namespace OrderAuditHistoryResponse
 */
export namespace OrderAuditHistoryResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        BASIC = <any> 'BASIC'
    }
}

/**
 * 
 * @export
 * @interface OrderBasicInfoResponse
 */
export interface OrderBasicInfoResponse {
    /**
     * 
     * @type {string}
     * @memberof OrderBasicInfoResponse
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderBasicInfoResponse
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderBasicInfoResponse
     */
    customer_message?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderBasicInfoResponse
     */
    district?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderBasicInfoResponse
     */
    gift?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderBasicInfoResponse
     */
    province?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderBasicInfoResponse
     */
    receiver_name?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderBasicInfoResponse
     */
    receiver_phone?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderBasicInfoResponse
     */
    street?: string;
}

/**
 * 
 * @export
 * @interface OrderContentResponse
 */
export interface OrderContentResponse {
    /**
     * 
     * @type {OrderBasicInfoResponse}
     * @memberof OrderContentResponse
     */
    basic?: OrderBasicInfoResponse;
}

/**
 * 
 * @export
 * @interface OrderItemDiscountPromotionResponse
 */
export interface OrderItemDiscountPromotionResponse {
    /**
     * 
     * @type {number}
     * @memberof OrderItemDiscountPromotionResponse
     */
    discount_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemDiscountPromotionResponse
     */
    promotion_id?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemDiscountPromotionResponse
     */
    promotion_name?: string;
    /**
     * 2-PDP,3-ADP
     * @type {number}
     * @memberof OrderItemDiscountPromotionResponse
     */
    promotion_type?: OrderItemDiscountPromotionResponse.PromotionTypeEnum;
}

/**
 * @export
 * @namespace OrderItemDiscountPromotionResponse
 */
export namespace OrderItemDiscountPromotionResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum PromotionTypeEnum {
        NUMBER_2 = <any> 2,
        NUMBER_3 = <any> 3
    }
}

/**
 * 
 * @export
 * @interface OrderItemResponse
 */
export interface OrderItemResponse {
    /**
     * 
     * @type {number}
     * @memberof OrderItemResponse
     */
    cost_price?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemResponse
     */
    created_at?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemResponse
     */
    customer_id?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemResponse
     */
    discount_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemResponse
     */
    external_sku_code?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderItemResponse
     */
    is_presale?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderItemResponse
     */
    item_type?: OrderItemResponse.ItemTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof OrderItemResponse
     */
    market_price?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemResponse
     */
    order_id?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemResponse
     */
    order_item_id?: string;
    /**
     * 
     * @type {Array<OrderItemDiscountPromotionResponse>}
     * @memberof OrderItemResponse
     */
    promotions?: Array<OrderItemDiscountPromotionResponse>;
    /**
     * 
     * @type {number}
     * @memberof OrderItemResponse
     */
    purchased_quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemResponse
     */
    sell_price?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemResponse
     */
    sku_code?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemResponse
     */
    sku_id?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemResponse
     */
    sku_image?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemResponse
     */
    spu_description?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemResponse
     */
    spu_id?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemResponse
     */
    spu_name?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemResponse
     */
    updated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemResponse
     */
    variation_attribute_desc?: string;
    /**
     * 
     * @type {Array<KeyValue>}
     * @memberof OrderItemResponse
     */
    variation_attribute_list?: Array<KeyValue>;
}

/**
 * @export
 * @namespace OrderItemResponse
 */
export namespace OrderItemResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum ItemTypeEnum {
        NORMALITEM = <any> 'NORMAL_ITEM',
        FREEGIFT = <any> 'FREE_GIFT'
    }
}

/**
 * 
 * @export
 * @interface OrderPaymentRequest
 */
export interface OrderPaymentRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentRequest
     */
    general_payment_remark?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderPaymentRequest
     */
    total_amount: number;
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentRequest
     */
    trade_no: string;
    /**
     * payment trade time. Default value: current timestamp,Unit: milliseconds
     * @type {number}
     * @memberof OrderPaymentRequest
     */
    trade_timestamp?: number;
}

/**
 * 
 * @export
 * @interface OrderPromotionResponse
 */
export interface OrderPromotionResponse {
    /**
     * 活动优惠金额
     * @type {number}
     * @memberof OrderPromotionResponse
     */
    discount_amount?: number;
    /**
     * 活动结束时间
     * @type {number}
     * @memberof OrderPromotionResponse
     */
    end_time?: number;
    /**
     * 参与商品
     * @type {number}
     * @memberof OrderPromotionResponse
     */
    product_range?: number;
    /**
     * 活动名称
     * @type {string}
     * @memberof OrderPromotionResponse
     */
    promotion_name?: string;
    /**
     * 活动类型
     * @type {number}
     * @memberof OrderPromotionResponse
     */
    promotion_type?: number;
    /**
     * 活动规则
     * @type {string}
     * @memberof OrderPromotionResponse
     */
    rule_cn?: string;
    /**
     * 活动规则
     * @type {string}
     * @memberof OrderPromotionResponse
     */
    rule_en?: string;
    /**
     * 规则类型
     * @type {number}
     * @memberof OrderPromotionResponse
     */
    rule_type?: number;
    /**
     * 活动开始时间
     * @type {number}
     * @memberof OrderPromotionResponse
     */
    start_time?: number;
}

/**
 * 
 * @export
 * @interface OrderRemarkHistoryRequest
 */
export interface OrderRemarkHistoryRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderRemarkHistoryRequest
     */
    remark: string;
}

/**
 * 
 * @export
 * @interface OrderResponse
 */
export interface OrderResponse {
    /**
     * 实际支付价格
     * @type {number}
     * @memberof OrderResponse
     */
    actual_paid_price?: number;
    /**
     * 取消时间
     * @type {string}
     * @memberof OrderResponse
     */
    cancel_at?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderResponse
     */
    cancel_type?: OrderResponse.CancelTypeEnum;
    /**
     * 承载店铺的电商渠道名称
     * @type {string}
     * @memberof OrderResponse
     */
    channel_name?: string;
    /**
     * 完成订单时间
     * @type {string}
     * @memberof OrderResponse
     */
    complete_at?: string;
    /**
     * 订单创建时间
     * @type {string}
     * @memberof OrderResponse
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderResponse
     */
    created_by?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderResponse
     */
    created_by_user_id?: number;
    /**
     * 下单用户Id
     * @type {string}
     * @memberof OrderResponse
     */
    customer_id?: string;
    /**
     * 留言
     * @type {string}
     * @memberof OrderResponse
     */
    customer_message?: string;
    /**
     * 地址信息
     * @type {DeliveryAddressResponse}
     * @memberof OrderResponse
     */
    delivery_address?: DeliveryAddressResponse;
    /**
     * 物流单号Id
     * @type {string}
     * @memberof OrderResponse
     */
    delivery_id?: string;
    /**
     * 订单的外部Id
     * @type {string}
     * @memberof OrderResponse
     */
    external_order_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderResponse
     */
    has_presale_item?: boolean;
    /**
     * 是否对商品做礼品包装
     * @type {boolean}
     * @memberof OrderResponse
     */
    is_gift?: boolean;
    /**
     * 订单优惠信息
     * @type {Array<OrderPromotionResponse>}
     * @memberof OrderResponse
     */
    order_promotion_list?: Array<OrderPromotionResponse>;
    /**
     * 订单商品列表
     * @type {Array<OrderItemResponse>}
     * @memberof OrderResponse
     */
    order_sku_item_list?: Array<OrderItemResponse>;
    /**
     * 
     * @type {string}
     * @memberof OrderResponse
     */
    order_source?: OrderResponse.OrderSourceEnum;
    /**
     * orderStatus
     * @type {string}
     * @memberof OrderResponse
     */
    order_status?: OrderResponse.OrderStatusEnum;
    /**
     * 支付时间
     * @type {string}
     * @memberof OrderResponse
     */
    pay_at?: string;
    /**
     * 支付详情
     * @type {PaymentResponse}
     * @memberof OrderResponse
     */
    payment_detail?: PaymentResponse;
    /**
     * 支付的Id
     * @type {string}
     * @memberof OrderResponse
     */
    payment_id?: string;
    /**
     * 支付渠道
     * @type {string}
     * @memberof OrderResponse
     */
    payment_source?: string;
    /**
     * 发货时间
     * @type {string}
     * @memberof OrderResponse
     */
    ship_at?: string;
    /**
     * 运费
     * @type {number}
     * @memberof OrderResponse
     */
    shipping_fee?: number;
    /**
     * 在各渠道类型上的店铺站点名称
     * @type {string}
     * @memberof OrderResponse
     */
    storefront_name?: string;
    /**
     * 不含运费的商品总额
     * @type {number}
     * @memberof OrderResponse
     */
    total_product_price?: number;
    /**
     * 未支付订单自动取消时间
     * @type {string}
     * @memberof OrderResponse
     */
    unpaid_auto_cancel_at?: string;
}

/**
 * @export
 * @namespace OrderResponse
 */
export namespace OrderResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum CancelTypeEnum {
        AUTOCANCELLED = <any> 'AUTO_CANCELLED',
        CANCELLEDBYCUSTOMER = <any> 'CANCELLED_BY_CUSTOMER'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum OrderSourceEnum {
        ONLINECUSTOMER = <any> 'ONLINE_CUSTOMER',
        OFFLINEBUSINESS = <any> 'OFFLINE_BUSINESS'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum OrderStatusEnum {
        WAITINGFORPAYMENT = <any> 'WAITING_FOR_PAYMENT',
        WAITINGFORDELIVERY = <any> 'WAITING_FOR_DELIVERY',
        WAITINGFORCONFIRMED = <any> 'WAITING_FOR_CONFIRMED',
        COMPLETED = <any> 'COMPLETED',
        CANCELLED = <any> 'CANCELLED',
        CLOSED = <any> 'CLOSED'
    }
}

/**
 * 
 * @export
 * @interface OrderStatusHistoryResponse
 */
export interface OrderStatusHistoryResponse {
    /**
     * 状态创建时间
     * @type {string}
     * @memberof OrderStatusHistoryResponse
     */
    created_at?: string;
    /**
     * 订单Id
     * @type {string}
     * @memberof OrderStatusHistoryResponse
     */
    order_id?: string;
    /**
     * 订单状态
     * @type {string}
     * @memberof OrderStatusHistoryResponse
     */
    order_status?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderStatusHistoryResponse
     */
    updated_at?: string;
}

/**
 * 
 * @export
 * @interface OrderStatusResponse
 */
export interface OrderStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof OrderStatusResponse
     */
    cn_name?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderStatusResponse
     */
    en_name?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderStatusResponse
     */
    key_name?: string;
}

/**
 * 
 * @export
 * @interface OrderStatusUpdateRequest
 */
export interface OrderStatusUpdateRequest {
    /**
     * 
     * @type {boolean}
     * @memberof OrderStatusUpdateRequest
     */
    need_rollback_inventory?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderStatusUpdateRequest
     */
    order_status: OrderStatusUpdateRequest.OrderStatusEnum;
}

/**
 * @export
 * @namespace OrderStatusUpdateRequest
 */
export namespace OrderStatusUpdateRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum OrderStatusEnum {
        WAITINGFORDELIVERY = <any> 'WAITING_FOR_DELIVERY',
        WAITINGFORCONFIRMED = <any> 'WAITING_FOR_CONFIRMED',
        COMPLETED = <any> 'COMPLETED',
        CANCELLED = <any> 'CANCELLED',
        CLOSED = <any> 'CLOSED'
    }
}

/**
 * 
 * @export
 * @interface PageQueryResponseRemarkHistoryResponse
 */
export interface PageQueryResponseRemarkHistoryResponse {
    /**
     * 
     * @type {number}
     * @memberof PageQueryResponseRemarkHistoryResponse
     */
    current_page?: number;
    /**
     * 
     * @type {Array<RemarkHistoryResponse>}
     * @memberof PageQueryResponseRemarkHistoryResponse
     */
    list?: Array<RemarkHistoryResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageQueryResponseRemarkHistoryResponse
     */
    num?: number;
    /**
     * 
     * @type {number}
     * @memberof PageQueryResponseRemarkHistoryResponse
     */
    total_num?: number;
    /**
     * 
     * @type {number}
     * @memberof PageQueryResponseRemarkHistoryResponse
     */
    total_page?: number;
}

/**
 * 
 * @export
 * @interface PageQueryResponseSimpleOrderResponse
 */
export interface PageQueryResponseSimpleOrderResponse {
    /**
     * 
     * @type {number}
     * @memberof PageQueryResponseSimpleOrderResponse
     */
    current_page?: number;
    /**
     * 
     * @type {Array<SimpleOrderResponse>}
     * @memberof PageQueryResponseSimpleOrderResponse
     */
    list?: Array<SimpleOrderResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageQueryResponseSimpleOrderResponse
     */
    num?: number;
    /**
     * 
     * @type {number}
     * @memberof PageQueryResponseSimpleOrderResponse
     */
    total_num?: number;
    /**
     * 
     * @type {number}
     * @memberof PageQueryResponseSimpleOrderResponse
     */
    total_page?: number;
}

/**
 * 
 * @export
 * @interface PaymentResponse
 */
export interface PaymentResponse {
    /**
     * 
     * @type {number}
     * @memberof PaymentResponse
     */
    actual_paid_price?: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentResponse
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentResponse
     */
    general_payment_remark?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentResponse
     */
    payment_status?: PaymentResponse.PaymentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PaymentResponse
     */
    payment_type?: PaymentResponse.PaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PaymentResponse
     */
    trade_no?: string;
}

/**
 * @export
 * @namespace PaymentResponse
 */
export namespace PaymentResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum PaymentStatusEnum {
        UNPAY = <any> 'UNPAY',
        SUCCESS = <any> 'SUCCESS',
        FINISHED = <any> 'FINISHED',
        CLOSED = <any> 'CLOSED',
        FAIL = <any> 'FAIL'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PaymentTypeEnum {
        WECHATMINIAPP = <any> 'WECHAT_MINI_APP',
        WECHATQRCODE = <any> 'WECHAT_QRCODE',
        WECHATWAP = <any> 'WECHAT_WAP',
        ALIWEB = <any> 'ALI_WEB',
        ALIWAP = <any> 'ALI_WAP',
        UNIONWEB = <any> 'UNION_WEB',
        UNIONWAP = <any> 'UNION_WAP',
        GENERAL = <any> 'GENERAL'
    }
}

/**
 * 
 * @export
 * @interface RemarkHistoryResponse
 */
export interface RemarkHistoryResponse {
    /**
     * 
     * @type {string}
     * @memberof RemarkHistoryResponse
     */
    order_id?: string;
    /**
     * 
     * @type {string}
     * @memberof RemarkHistoryResponse
     */
    remark?: string;
    /**
     * 
     * @type {string}
     * @memberof RemarkHistoryResponse
     */
    updated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof RemarkHistoryResponse
     */
    updater_name?: string;
}

/**
 * 
 * @export
 * @interface SimpleOrderResponse
 */
export interface SimpleOrderResponse {
    /**
     * 实付总金额(实付总金额=商品总额-优惠金额+运费)
     * @type {number}
     * @memberof SimpleOrderResponse
     */
    actual_paid_price?: number;
    /**
     * 承载站点的渠道名称
     * @type {string}
     * @memberof SimpleOrderResponse
     */
    channel_name?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleOrderResponse
     */
    created_at?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SimpleOrderResponse
     */
    has_presale_item?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SimpleOrderResponse
     */
    order_id?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleOrderResponse
     */
    order_status?: SimpleOrderResponse.OrderStatusEnum;
    /**
     * 收货人名字
     * @type {string}
     * @memberof SimpleOrderResponse
     */
    receiver_name?: string;
    /**
     * 收货人手机
     * @type {string}
     * @memberof SimpleOrderResponse
     */
    receiver_phone?: string;
    /**
     * 站点名称
     * @type {string}
     * @memberof SimpleOrderResponse
     */
    storefront_name?: string;
    /**
     * 物流单号
     * @type {string}
     * @memberof SimpleOrderResponse
     */
    tracking_number?: string;
}

/**
 * @export
 * @namespace SimpleOrderResponse
 */
export namespace SimpleOrderResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum OrderStatusEnum {
        WAITINGFORPAYMENT = <any> 'WAITING_FOR_PAYMENT',
        WAITINGFORDELIVERY = <any> 'WAITING_FOR_DELIVERY',
        WAITINGFORCONFIRMED = <any> 'WAITING_FOR_CONFIRMED',
        COMPLETED = <any> 'COMPLETED',
        CANCELLED = <any> 'CANCELLED',
        CLOSED = <any> 'CLOSED'
    }
}

/**
 * 
 * @export
 * @interface UpdateOrderPaymentRequest
 */
export interface UpdateOrderPaymentRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderPaymentRequest
     */
    general_payment_remark?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderPaymentRequest
     */
    trade_no?: string;
}

/**
 * 
 * @export
 * @interface UpdatePartialOrderRequest
 */
export interface UpdatePartialOrderRequest {
    /**
     * 订单留言
     * @type {string}
     * @memberof UpdatePartialOrderRequest
     */
    customer_message?: string;
    /**
     * 
     * @type {DeliveryAddressRequest}
     * @memberof UpdatePartialOrderRequest
     */
    delivery_address: DeliveryAddressRequest;
    /**
     * 是否对商品做礼品包装
     * @type {boolean}
     * @memberof UpdatePartialOrderRequest
     */
    is_gift?: boolean;
}




export interface IgetAuditHistoryListParams {
  
  type?: 'BASIC', 
  order_id: string, 
  
}

/**
 *OrderAuditHistoryControllerApi - fetch parameter creator
 *@export
 */
export const OrderAuditHistoryControllerApiParamCreator = {
  /**
    *
    *@summary retrieve all the audit history by order_id and type
    *@param {string} cookie 
    *@param {string} order_id order_id
    *@param {'BASIC'} [type] 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getAuditHistoryList(params = {} as IgetAuditHistoryListParams, options: any = {}): FetchArgs {
    const {  order_id,  type,   } = params

    // verify required path 'order_id' is not null or undefined
    if (order_id === null || order_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('order_id', 'Required parameter order_id was null or undefined when calling getAuditHistoryList.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/order".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/order/{order_id}/history`.includes(prefix) ? `/business/v1/order/{order_id}/history` : prefix + `/business/v1/order/{order_id}/history`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"order_id"}}`, encodeURIComponent(String(order_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (type !== undefined) {
        localVarQueryParameter.type = type;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IdetailUsingGETParams {
  
  
  order_id: string, 
  
}
export interface IexportAllOrdersUsingGETParams {
  
  
  
  
}
export interface IlistSimpleOrderUsingGETParams {
  
  has_presale_item?: boolean, order_created_at_end?: string, order_created_at_start?: string, order_status?: string, storefront_id?: string, channel?: number, filters?: string, keyword?: string, num?: number, page?: number, 
  
  
}
export interface IupdatePartialOrderUsingPUTParams {
  request: UpdatePartialOrderRequest, 
  
  order_id: string, 
  
}
export interface IupdateStatusUsingPUTParams {
  request: OrderStatusUpdateRequest, 
  
  order_id: string, 
  
}

/**
 *OrderBusinessControllerApi - fetch parameter creator
 *@export
 */
export const OrderBusinessControllerApiParamCreator = {
  /**
    *
    *@summary retrieve the detail of a specific order by order id
    *@param {string} cookie 
    *@param {string} order_id order_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  detailUsingGET(params = {} as IdetailUsingGETParams, options: any = {}): FetchArgs {
    const {  order_id,    } = params

    // verify required path 'order_id' is not null or undefined
    if (order_id === null || order_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('order_id', 'Required parameter order_id was null or undefined when calling detailUsingGET.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/order".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/order/{order_id}`.includes(prefix) ? `/business/v1/order/{order_id}` : prefix + `/business/v1/order/{order_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"order_id"}}`, encodeURIComponent(String(order_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary exportAllOrders
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  exportAllOrdersUsingGET(params = {} as IexportAllOrdersUsingGETParams, options: any = {}): FetchArgs {
    const {     } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/order".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/order/export`.includes(prefix) ? `/business/v1/order/export` : prefix + `/business/v1/order/export`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve a simple orders list by condition
    *@param {string} cookie 
    *@param {boolean} [has_presale_item] 
    *@param {string} [order_created_at_end] 
    *@param {string} [order_created_at_start] 
    *@param {string} [order_status] 
    *@param {string} [storefront_id] 
    *@param {number} [channel] 
    *@param {string} [filters] 
    *@param {string} [keyword] 
    *@param {number} [num] 
    *@param {number} [page] 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  listSimpleOrderUsingGET(params = {} as IlistSimpleOrderUsingGETParams, options: any = {}): FetchArgs {
    const {   has_presale_item, order_created_at_end, order_created_at_start, order_status, storefront_id, channel, filters, keyword, num, page,   } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/order".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/order/list`.includes(prefix) ? `/business/v1/order/list` : prefix + `/business/v1/order/list`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (has_presale_item !== undefined) {
        localVarQueryParameter.has_presale_item = has_presale_item;
    }

    if (order_created_at_end !== undefined) {
        localVarQueryParameter.order_created_at_end = order_created_at_end;
    }

    if (order_created_at_start !== undefined) {
        localVarQueryParameter.order_created_at_start = order_created_at_start;
    }

    if (order_status !== undefined) {
        localVarQueryParameter.order_status = order_status;
    }

    if (storefront_id !== undefined) {
        localVarQueryParameter.storefront_id = storefront_id;
    }

    if (channel !== undefined) {
        localVarQueryParameter.channel = channel;
    }

    if (filters !== undefined) {
        localVarQueryParameter.filters = filters;
    }

    if (keyword !== undefined) {
        localVarQueryParameter.keyword = keyword;
    }

    if (num !== undefined) {
        localVarQueryParameter.num = num;
    }

    if (page !== undefined) {
        localVarQueryParameter.page = page;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update order section information
    *@param {string} cookie 
    *@param {string} order_id order_id
    *@param {UpdatePartialOrderRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updatePartialOrderUsingPUT(params = {} as IupdatePartialOrderUsingPUTParams, options: any = {}): FetchArgs {
    const { request,  order_id,    } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling updatePartialOrderUsingPUT.');
    }

    // verify required path 'order_id' is not null or undefined
    if (order_id === null || order_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('order_id', 'Required parameter order_id was null or undefined when calling updatePartialOrderUsingPUT.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/order".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/order/{order_id}`.includes(prefix) ? `/business/v1/order/{order_id}` : prefix + `/business/v1/order/{order_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"order_id"}}`, encodeURIComponent(String(order_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PUT', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UpdatePartialOrderRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update status for a specific order by order_id
    *@param {string} cookie 
    *@param {string} order_id order_id
    *@param {OrderStatusUpdateRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateStatusUsingPUT(params = {} as IupdateStatusUsingPUTParams, options: any = {}): FetchArgs {
    const { request,  order_id,    } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling updateStatusUsingPUT.');
    }

    // verify required path 'order_id' is not null or undefined
    if (order_id === null || order_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('order_id', 'Required parameter order_id was null or undefined when calling updateStatusUsingPUT.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/order".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/order/{order_id}/status`.includes(prefix) ? `/business/v1/order/{order_id}/status` : prefix + `/business/v1/order/{order_id}/status`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"order_id"}}`, encodeURIComponent(String(order_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PUT', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"OrderStatusUpdateRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IgetInvoiceUsingGETParams {
  
  
  order_id: string, 
  
}

/**
 *OrderInvoiceControllerApi - fetch parameter creator
 *@export
 */
export const OrderInvoiceControllerApiParamCreator = {
  /**
    *
    *@summary retrieve detail for a specific invoice by order id
    *@param {string} cookie 
    *@param {string} order_id order_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getInvoiceUsingGET(params = {} as IgetInvoiceUsingGETParams, options: any = {}): FetchArgs {
    const {  order_id,    } = params

    // verify required path 'order_id' is not null or undefined
    if (order_id === null || order_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('order_id', 'Required parameter order_id was null or undefined when calling getInvoiceUsingGET.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/order".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/order/{order_id}/invoice`.includes(prefix) ? `/business/v1/order/{order_id}/invoice` : prefix + `/business/v1/order/{order_id}/invoice`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"order_id"}}`, encodeURIComponent(String(order_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IconfirmOrderPaymentUsingPOSTParams {
  request: OrderPaymentRequest, 
  
  order_id: string, 
  
}
export interface IupdateOrderPaymentUsingPUTParams {
  request: UpdateOrderPaymentRequest, 
  
  order_id: string, 
  
}

/**
 *OrderPaymentControllerApi - fetch parameter creator
 *@export
 */
export const OrderPaymentControllerApiParamCreator = {
  /**
    *
    *@summary Submit payment for a specific order
    *@param {string} cookie 
    *@param {string} order_id order_id
    *@param {OrderPaymentRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  confirmOrderPaymentUsingPOST(params = {} as IconfirmOrderPaymentUsingPOSTParams, options: any = {}): FetchArgs {
    const { request,  order_id,    } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling confirmOrderPaymentUsingPOST.');
    }

    // verify required path 'order_id' is not null or undefined
    if (order_id === null || order_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('order_id', 'Required parameter order_id was null or undefined when calling confirmOrderPaymentUsingPOST.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/order".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/order/{order_id}/payment`.includes(prefix) ? `/business/v1/order/{order_id}/payment` : prefix + `/business/v1/order/{order_id}/payment`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"order_id"}}`, encodeURIComponent(String(order_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"OrderPaymentRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update a specific order general payment info
    *@param {string} cookie 
    *@param {string} order_id order_id
    *@param {UpdateOrderPaymentRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateOrderPaymentUsingPUT(params = {} as IupdateOrderPaymentUsingPUTParams, options: any = {}): FetchArgs {
    const { request,  order_id,    } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling updateOrderPaymentUsingPUT.');
    }

    // verify required path 'order_id' is not null or undefined
    if (order_id === null || order_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('order_id', 'Required parameter order_id was null or undefined when calling updateOrderPaymentUsingPUT.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/order".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/order/{order_id}/payment`.includes(prefix) ? `/business/v1/order/{order_id}/payment` : prefix + `/business/v1/order/{order_id}/payment`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"order_id"}}`, encodeURIComponent(String(order_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PUT', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UpdateOrderPaymentRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IlistRemarkUsingGETParams {
  
  num?: number, page?: number, 
  order_id: string, 
  
}
export interface IupdateRemarkUsingPOSTParams {
  request: OrderRemarkHistoryRequest, 
  
  order_id: string, 
  
}

/**
 *OrderRemarkControllerApi - fetch parameter creator
 *@export
 */
export const OrderRemarkControllerApiParamCreator = {
  /**
    *
    *@summary retrieve remark list by order_id
    *@param {string} cookie 
    *@param {string} order_id order_id
    *@param {number} [num] 
    *@param {number} [page] 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  listRemarkUsingGET(params = {} as IlistRemarkUsingGETParams, options: any = {}): FetchArgs {
    const {  order_id,  num, page,   } = params

    // verify required path 'order_id' is not null or undefined
    if (order_id === null || order_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('order_id', 'Required parameter order_id was null or undefined when calling listRemarkUsingGET.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/order".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/order/{order_id}/remarks`.includes(prefix) ? `/business/v1/order/{order_id}/remarks` : prefix + `/business/v1/order/{order_id}/remarks`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"order_id"}}`, encodeURIComponent(String(order_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (num !== undefined) {
        localVarQueryParameter.num = num;
    }

    if (page !== undefined) {
        localVarQueryParameter.page = page;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary Update remark of a specific order by order_id
    *@param {string} cookie 
    *@param {string} order_id order_id
    *@param {OrderRemarkHistoryRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateRemarkUsingPOST(params = {} as IupdateRemarkUsingPOSTParams, options: any = {}): FetchArgs {
    const { request,  order_id,    } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling updateRemarkUsingPOST.');
    }

    // verify required path 'order_id' is not null or undefined
    if (order_id === null || order_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('order_id', 'Required parameter order_id was null or undefined when calling updateRemarkUsingPOST.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/order".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/order/{order_id}/remark`.includes(prefix) ? `/business/v1/order/{order_id}/remark` : prefix + `/business/v1/order/{order_id}/remark`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"order_id"}}`, encodeURIComponent(String(order_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"OrderRemarkHistoryRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IgetAllOrderStatusUsingGETParams {
  
  
  
  
}

/**
 *OrderStatusControllerApi - fetch parameter creator
 *@export
 */
export const OrderStatusControllerApiParamCreator = {
  /**
    *
    *@summary get all order status
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getAllOrderStatusUsingGET(params = {} as IgetAllOrderStatusUsingGETParams, options: any = {}): FetchArgs {
    const {     } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/order".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/order/status`.includes(prefix) ? `/business/v1/order/status` : prefix + `/business/v1/order/status`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IlistStatusHistoryUsingGETParams {
  
  
  order_id: string, 
  
}

/**
 *OrderStatusHistoryControllerApi - fetch parameter creator
 *@export
 */
export const OrderStatusHistoryControllerApiParamCreator = {
  /**
    *
    *@summary retrieve the status list for a specific order by order_id
    *@param {string} cookie 
    *@param {string} order_id order_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  listStatusHistoryUsingGET(params = {} as IlistStatusHistoryUsingGETParams, options: any = {}): FetchArgs {
    const {  order_id,    } = params

    // verify required path 'order_id' is not null or undefined
    if (order_id === null || order_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('order_id', 'Required parameter order_id was null or undefined when calling listStatusHistoryUsingGET.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/order".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/order/{order_id}/status_list`.includes(prefix) ? `/business/v1/order/{order_id}/status_list` : prefix + `/business/v1/order/{order_id}/status_list`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"order_id"}}`, encodeURIComponent(String(order_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};


